/**
 * @fileoverview Zod schemas for My Page's "Reassign" and "Request reassignment" forms.
 * @description Both name the person to hand the target to. A reassignment's reason is optional; an
 * Executive's request needs one (1-500 characters). Messages are translation keys, translated only
 * at the display call site in MyPageReassignDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

import { MY_PAGE_REASON_MAX_LENGTH } from '@/features/sales/constants/my-page.constants'

/** @description The reassign form's rules (reason optional). */
export const myPageReassignFormSchema = z.object({
  assigneeUserId: z.string().trim().min(1, 'sales.myWork.dialogs.reassign.errors.assigneeRequired'),
  reason: z
    .string()
    .trim()
    .max(MY_PAGE_REASON_MAX_LENGTH, 'sales.myWork.dialogs.errors.reasonTooLong'),
})

/** @description The request-reassignment form's rules (reason required). */
export const myPageRequestReassignmentFormSchema = myPageReassignFormSchema.extend({
  reason: z
    .string()
    .trim()
    .min(1, 'sales.myWork.dialogs.errors.reasonRequired')
    .max(MY_PAGE_REASON_MAX_LENGTH, 'sales.myWork.dialogs.errors.reasonTooLong'),
})

/** @description The values both reassignment forms hold. */
export type MyPageReassignFormValues = z.infer<typeof myPageReassignFormSchema>
